import { Stepper } from "@frends/ui-components/react";

export default Stepper;
